module.exports = __webpack_public_path__ + "static/solidarity-labs-2-21fc07494ed587cdae8846d5f4b9388f.jpg";